// 性格画像展示共享组件:15 维(行为特质/动机/价值观)条形图 + 元数据
// 被 Town 档案面板与独立"性格档案页"共用,保证两处展示一致。

export const PERSONALITY_GROUPS: { title: string; dims: { id: string; label: string; color: string }[] }[] = [
  {
    title: "行为特质",
    dims: [
      { id: "openness", label: "开放性", color: "#8b5cf6" },
      { id: "conscientiousness", label: "尽责性", color: "#0ea5e9" },
      { id: "extraversion", label: "外向性", color: "#f59e0b" },
      { id: "agreeableness", label: "宜人性", color: "#22c55e" },
      { id: "stability", label: "情绪稳定", color: "#ef4444" },
      { id: "expressiveness", label: "表达欲", color: "#e11d48" },
      { id: "romanticism", label: "浪漫性", color: "#c084fc" },
    ],
  },
  {
    title: "动机(麦克利兰)",
    dims: [
      { id: "mot_achievement", label: "成就", color: "#f59e0b" },
      { id: "mot_power", label: "权力", color: "#3b82f6" },
      { id: "mot_affiliation", label: "亲和", color: "#22c55e" },
    ],
  },
  {
    title: "价值观(施瓦茨·城镇版)",
    dims: [
      { id: "val_achievement", label: "自我成就", color: "#f59e0b" },
      { id: "val_pleasure", label: "享乐", color: "#f97316" },
      { id: "val_autonomy", label: "自由创造", color: "#8b5cf6" },
      { id: "val_benevolence", label: "关爱他人", color: "#22c55e" },
      { id: "val_tradition", label: "安稳传统", color: "#78716c" },
    ],
  },
];

export const ALL_PERSONALITY_DIMS: { id: string; label: string; group: string }[] = PERSONALITY_GROUPS.flatMap((g) =>
  g.dims.map((d) => ({ id: d.id, label: d.label, group: g.title }))
);

export function PersonalityBars({ scores }: { scores: Record<string, number> }) {
  return (
    <div className="space-y-2">
      {PERSONALITY_GROUPS.map((g) => (
        <div key={g.title}>
          <div className="text-[10px] font-black text-[#b39c4f] mb-0.5">{g.title}</div>
          <div className="space-y-1">
            {g.dims.map((d) => {
              const v = Math.max(0, Math.min(100, Number(scores?.[d.id]) || 0));
              return (
                <div key={d.id} className="flex items-center gap-2 text-xs">
                  <span className="w-14 shrink-0 text-[#8a8571]">{d.label}</span>
                  <div className="flex-1 h-2 rounded-full bg-[#efe9d5] overflow-hidden">
                    <div className="h-full rounded-full" style={{ width: `${v}%`, background: d.color }} />
                  </div>
                  <span className="w-8 text-right font-bold text-[#6b6252]">{v}</span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export function PersonalityPanel({ scores, day }: { scores: Record<string, number>; day: number }) {
  return (
    <div className="mt-2">
      <PersonalityBars scores={scores} />
      <div className="text-[10px] text-[#a9a494] mt-1">性格画像 · 第{day}天快照(含每日小波动)</div>
    </div>
  );
}
